// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/*\n  Hide the default reCAPTCHA badge; disclose use of reCAPTCHA on pages where it runs (e.g. contact\n  form).\n*/\n.grecaptcha-badge {\n  visibility: hidden;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
